import React from "react"
import { Link } from "gatsby"
import Newsletter from "./parts/Newsletter"

import { RiExternalLinkLine } from "react-icons/ri"
import { RiFacebookBoxLine } from "react-icons/ri"
import { RiInstagramLine } from "react-icons/ri"
import { RiLinkedinBoxLine } from "react-icons/ri"

const Footer = () => {
  return (
    <footer className="pt-5 pb-4">
      <div className="container">
        <div className="row justify-content-between">
          <div className="col-lg-4">
            <div className="social-media mb-4">
              <p className="mb-1">S'abonner à ma newsletter</p>
              <Newsletter />
              <p className="mb-1">Me suivre sur les réseaux sociaux</p>
              <a
                href="https://www.facebook.com/catherinecoutensophrologue"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="sr-only">Facebook</span>
                <RiFacebookBoxLine size="2.2rem" className="mr-2" />
              </a>
              <a
                href="https://www.instagram.com/catherinecouten/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="sr-only">Instagram</span>
                <RiInstagramLine size="2rem" className="mr-2" />
              </a>
              <a
                href="https://www.linkedin.com/in/catherine-couten-2aa3a011/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="sr-only">LinkedIn</span>
                <RiLinkedinBoxLine size="2.2rem" />
              </a>
            </div>
          </div>
          <div className="col-lg-7 infos">
            <p>
              <Link to="/mentions-legales" title="Mentions légales">
                Mentions légales
              </Link>{" "}
              |{" "}
              <Link
                to="/politique-confidentialite"
                title="Politique de confidentialité"
              >
                Politique de confidentialité
              </Link>
            </p>
            <p>
              Sites amis :{" "}
              <a
                href="http://www.orientea.net/"
                target="_blank"
                rel="noreferrer"
                title="Orientea"
              >
                Orientea <RiExternalLinkLine />
              </a>{" "}
              |{" "}
              <a
                href="http://www.essasophro.com/"
                target="_blank"
                rel="noreferrer"
                title="ESSA"
              >
                ESSA <RiExternalLinkLine />
              </a>{" "}
              |{" "}
              <a
                href="https://www.osteonature.fr/"
                target="_blank"
                rel="noreferrer"
                title="Ostéonature"
              >
                Ostéonature <RiExternalLinkLine />
              </a>
            </p>
            <p>
              Tous droits réservés{" "}
              <a href="http://catherinecouten-sophrologue.com/">
                Catherine Couten E.I.
              </a>
              <br />
              SIRET : 529 350 779 00011
              <br />
              Organisme de formation enregistré sous le numéro 22 60 02604 60.
              <br />
              Cet enregistrement ne vaut pas agrément de l’Etat.
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
